// Copyright (c) 2017 Deere & Company

import './report-columns.scss';
import React, {PropTypes} from 'react';
import ReportColumnState from '@deere/cps-it.warranty-model-factory/lib/report-layout-column-state';

const ReportHiddenColumns = props =>
    props.hiddenColumns.length ?
        <section className='report-hidden-columns'>
            <div className='hidden-columns-header'>
                <button
                    className='icon-close-medium'
                    onClick={props.actions.onClose}
                />
            </div>
            {
                props.hiddenColumns.map((column, index) =>
                    <button
                        className='column-name'
                        key={index}
                        onClick={props.actions.onClick.bind(null, column.colId)}
                    >
                        {props.columnApi.getColumn(column.colId).colDef.headerName}
                    </button>
                )

            }
        </section> :
        null;

ReportHiddenColumns.displayName = 'ReportHiddenColumns';
ReportHiddenColumns.propTypes = {
    actions: PropTypes.object.isRequired,
    columnApi: PropTypes.object.isRequired,
    hiddenColumns: PropTypes.arrayOf(PropTypes.instanceOf(ReportColumnState))
};

export default ReportHiddenColumns;



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-columns/report-columns.js